import React from 'react';
import Person from '../../../models/Person';
import User from '../../../models/User';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, darken } from  '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import { personTypeToDescription } from '../../Client/Profile';
import { useThemeContext } from '../../../theme/ThemeContext';
import moment from 'moment';

export interface Row {
  data: Person & User
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  fromIn?: boolean;
  adminInfo?: boolean;
  managerInfo?: boolean;
  headsalesInfo?: boolean;
  onClickInfo?: (person: Person) => void;
  onChangePage?: (page: number) => void;
}

const People: React.FC<Props> = (props) => {  
  const { t } = useTranslation('person')
  const { theme } = useThemeContext()

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }
  return (
      <Paper style={{borderRadius: "10px", margin: props.fromIn ? "-10px" : "10px"}}>
      { !props.fromIn && <ISTableTitle title={t('title')}/> }
      <Table style={{whiteSpace:"nowrap", overflow:"hidden"}} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell>{t('firstName')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('lastName')}</ISTableHeaderCell>
            { !props.fromIn && <ISTableHeaderCell align='right'>{t('documentNumber')}</ISTableHeaderCell>}
            <ISTableHeaderCell>{t('email')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('phoneNumber')}</ISTableHeaderCell>
            {/* <ISTableHeaderCell>{t('address')}</ISTableHeaderCell> 
            { !props.fromIn && <ISTableHeaderCell align='center'>{t('zipCode')}</ISTableHeaderCell>}
            { !props.fromIn && <ISTableHeaderCell>{t('locality')}</ISTableHeaderCell>}*/}
            { !props.fromIn && <ISTableHeaderCell>{t('province')}</ISTableHeaderCell>}
            { !props.fromIn && <ISTableHeaderCell>{t('personType')}</ISTableHeaderCell>}
            { !props.fromIn && <ISTableHeaderCell align='right'>{t('byPersonTypeId')}</ISTableHeaderCell>}
            <ISTableHeaderCell>{t('position')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('expired')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { !props.loading && props.rows.filter(p => props.adminInfo || 
          ( props.managerInfo && p.data.personType !== 'A' ) || 
          ( props.headsalesInfo && p.data.personType !== 'A' && p.data.personType !== 'M' ) || p.data.personType === 'C').map((row, index) =>
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{cursor: 'pointer', backgroundColor: row.data.expiredDate ? darken(theme.palette.action.hover, 0.1) : ''}}
            onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data) }}>
              <TableCell>{row.data.firstName}</TableCell>
              <TableCell>{row.data.lastName}</TableCell>
              { !props.fromIn && <TableCell align='right'>{row.data.documentNumber}</TableCell>}
              <TableCell>{row.data.email}</TableCell>
              <TableCell>{row.data.phoneNumber}</TableCell>
              {/*<TableCell>{row.data.address}</TableCell>
              { !props.fromIn && <TableCell align='center'>{row.data.zipCode}</TableCell>}
              { !props.fromIn && <TableCell>{row.data.locality}</TableCell>}*/}
              { !props.fromIn && <TableCell>{row.data.province}</TableCell>}
              { !props.fromIn && <TableCell>{t(`${personTypeToDescription(row.data.personType)}`)}</TableCell>}
              { !props.fromIn && <TableCell align='right'>{row.data.byPersonTypeId}</TableCell>}
              <TableCell>{row.data.position}</TableCell>
              <TableCell>{row.data.expiredDate ? moment(new Date(row.data.expiredDate)).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY'): t('active')}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      { props.loading &&
        <div style={{display:'flex', justifyContent:'center'}}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default People

